var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgChevronLeft = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "m11.812 15.625-5.27-5.27a.5.5 0 0 1 0-.707l5.27-5.27" }) }))); };
export default SvgChevronLeft;
